module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-full-on-toegangspass-5.7b9ca20e.jpg";